import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { GenotypingController } from 'src/controllers/genotyping.controller'
import { CreateGenotypingDto, GenotypingDto } from 'src/dto/genotyping.dto'

const genotypingController = new GenotypingController()

export function useCreateGenotyping() {
  const { userFarm: farmId } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CreateGenotypingDto) => genotypingController.createGenotyping(data),
    onSuccess: (data) => {
      queryClient.setQueryData(['getGenotypingList', farmId], (oldData: GenotypingDto[]) => {
        return [...oldData, data]
      })
    },
    onError: () => {
      toast.error('Erro ao criar genotipagem')
    }
  })
}
